import {
    DOMUtils,
    HttpRequest
} from "./Utils.js";
import {
    getCookie,
    setCookie,
    cookieEnum,
    removeCookie
} from "./cookie.js";
import {
    getAttr,
    resetAttr,
    setAttr
} from "./options.js";
import {
    sendLogin
} from "./home.js"
import {
    showImagePicker
} from "./liste.js"


window.$DOM = DOMUtils;

let opendialogs = [];

function customAlert(txt) {
    console.log(txt);
    let txtMsg;
    if (txt.error_msg) {
        txtMsg = txt.error_msg;
    } else {
        txtMsg = txt;
    }

    $DOM("#alert-div").html(txtMsg).removeClass("hidden");
    setTimeout(function (e) {
        $DOM("#alert-div").addClass("hidden");
    }, 2500);
    return txtMsg;
}

function customConfirm(txt, fnc) {
    $DOM("#confirmModal").removeClass("hidden");
    $DOM("#dialog-confirm-txt").html(txt);
    appendDialog($DOM("#confirmModal"));
    $DOM("#dialog-confirm-btncancel").on("click", closeDialogs);
    $DOM("#dialog-confirm-btnok").off();
    $DOM("#dialog-confirm-btnok").on("click", function () {
        closeDialogs();
        fnc();
    });
}


function appendDialog(e, removeImgName = true) {
    e.clearForm();
    const x = e.find("-form-error");
    x.html("");
    if (removeImgName) {
        $DOM(".upload-img-name").remove();
    }
    $DOM(".imagepicker-icon").off();
    $DOM(".imagepicker-icon").on("click", function (e) {
        const refId = $DOM(this).attr("ref-id");
        if (refId) {
            showImagePicker(refId);
        }
    });
    openDialogAdd(e);
}

function closeDialogs() {

    // todo: i should set those values with the form?
    // prevent bug where those are invalid empty or invalid filled

    navBarClose();
    $DOM("input").off("keyup", keyListnerLogin);
    var wasOpen = false;
    opendialogs.forEach((dialog) => {
        if (dialog.dialog("isOpen")) {
            wasOpen = true;
        }
        dialog.dialog("close");
    });
    opendialogs = [];
    return wasOpen;
}

function closeOneDialog(dialog) {
    var wasOpen = false;
    if (dialog.dialog("isOpen")) {
        wasOpen = true;
    }
    dialog.dialog("close");
    return wasOpen;
}

function navBarClose() {
    $DOM("#topNavbar").removeClass("responsive");
}


function abmelden() {
    new HttpRequest().send({
        url: "./php/api/user/logout.php",
        type: "POST",
        data: {
            token: getCookie(cookieEnum.token)
        }
    });
    /*
    .done(function (e) {
        console.log("done");
        customAlert(e);
    }).fail(function (e) {
        console.log("error");
        customAlert(e);
    })
    */

    removeCookie(cookieEnum.token)

    resetNavbar();

    $DOM("#dropdown-items").empty();

    $DOM("#list-screen").html(`<div class="screen-block liste">\n` +
        " <span>Du bist nicht angemeldet</span>\n" +
        " </div>");

    setAttr("user", null);
    setAttr("datagroups", null);
    setAttr("data", null);
    resetAttr();

    window.location = "#home";
}


function resetNavbar() {
    $DOM("#dropdown-items").empty();
    $DOM("#btn-login").addClass("hidden");
    $DOM("#btn-create-user").addClass("hidden");
    $DOM("#btn-userverwaltung").addClass("hidden");
    $DOM("#btn-create-room").addClass("hidden");
    $DOM("#btn-create-group").addClass("hidden");
}

function openDialogAdd(e) {
    opendialogs.push(e);
}

function keyListnerLogin(e) {
    if (e.which === 13) {
        sendLogin();
    }
}

function setButtonEvent(id, fn, param = undefined) {
    let e = document.getElementById(id);
    if (e) {
        // remove old handler
        var elClone = e.cloneNode(true);
        e.parentNode.replaceChild(elClone, e);

        if (param !== undefined){
            elClone.addEventListener("click", 
            function() {           // anonyme Funktion
                fn(param);  
             }, 
                false
             );
        } else {
            elClone.addEventListener("click", fn, false);
        }
    }
}

export {
    customAlert,
    customConfirm,
    closeDialogs,
    closeOneDialog,
    appendDialog,
    openDialogAdd,

    navBarClose,
    resetNavbar,

    abmelden,
    keyListnerLogin,

    setButtonEvent
}